import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class PaymentsToYouToastService  {

    messageDisplayed: boolean = false;

    constructor(private readonly messageService: ToastrService) {

    }

    newPayments(noOfNewPayments: number) {
      if (noOfNewPayments > 0) {

        this.messageService.info(
          `You have received ${noOfNewPayments} new payments! Check the Payments to you Widget.`,
          'Payments to You',
          { closeButton: true, disableTimeOut: true });
      }
      this.messageDisplayed = true;
    }

}



